// extracted by mini-css-extract-plugin
export default {"button":"scroll-to-top_button__KP5w+","hidden":"scroll-to-top_hidden__x14-l","shown":"scroll-to-top_shown__iotrt"};